import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Box } from '@givebutter/primitives/box';
import { Button } from '@givebutter/primitives/button';
import { updateCampaign } from 'api/campaigns';
import { CAMPAIGN_TEAM_MULTITEAM_FUNDRAISING_SETTINGS_LINK } from 'constants/links';
import { Settings } from 'constants/settings';
import { useCurrentCampaign } from 'customHooks/useCurrentCampaign';
import { campaignQueryKeys } from 'queries/campaign-query-keys';

const CampaignTeamsSplash = () => {
    const queryClient = useQueryClient();
    const { data: campaign } = useCurrentCampaign();
    const campaignId = campaign?.id!;
    const { mutate: enableMultiteamFundraising } = useMutation({
        mutationFn: () =>
            updateCampaign({
                campaignId,
                data: {
                    settings: [
                        {
                            code: Settings.EnableMultiTeam.Code,
                            active: true,
                        },
                    ],
                },
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: campaignQueryKeys.campaign(campaignId),
            });
        },
    });

    return (
        <Box className={'flex flex-wrap-reverse gap-8 p-8 sm:gap-12 sm:p-12'}>
            <div className={'flex flex-1 flex-col gap-2'}>
                <p className={'text-4xl font-medium'}>Team fundraising</p>
                <div className={'flex flex-col gap-6'}>
                    <p className={'text-lg font-medium'}>
                        Create teams for your campaign, let individuals join those teams, and show a
                        team leaderboard.{' '}
                        <a
                            target={'_blank'}
                            rel={'noopener noreferrer'}
                            href={CAMPAIGN_TEAM_MULTITEAM_FUNDRAISING_SETTINGS_LINK}
                        >
                            Learn more
                        </a>
                        .
                    </p>
                    <Button variant="solid" onClick={() => enableMultiteamFundraising()}>
                        Enable team fundraising
                    </Button>
                </div>
            </div>
            <div className={'flex-1'}>
                <img
                    className={
                        'w-[80%] min-w-[100px] max-w-[200px] sm:min-w-[125px] sm:max-w-[250px]'
                    }
                    alt="Team fundraising splash"
                    src={`/images/illustrations/team-fundraising.svg`}
                />
            </div>
        </Box>
    );
};

export { CampaignTeamsSplash };
